// extracted by mini-css-extract-plugin
export default {"menu_banner":"LM_T7iVvbzLjtDUIoTFE","menuBanner":"LM_T7iVvbzLjtDUIoTFE","menu_brands":"dB4SUdbpJZi9rbO0KNDI","menuBrands":"dB4SUdbpJZi9rbO0KNDI"};